
export type SearchUsersParams = {
query: string;
limit?: number;
};
